import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
const left = (h: number) => (h <= 0 ? 'PO TERMINIE' : (Math.floor(h) + ' h ' + Math.round((h - Math.floor(h)) * 60) + ' min'));

// Ostrzezenie: zamowienia AliExpress czekajace na wysylke, bez potwierdzonego zgloszenia przesylki do AliExpress
export default function AeShipAlert({ currentUser, onOpen }: { currentUser: any; onOpen: (numbers: string[]) => void }) {
  const [items, setItems] = useState<any[]>([]);
  const [copied, setCopied] = useState('');
  const copy = (t: string) => {
    try { navigator.clipboard.writeText(t).then(() => { setCopied(t); window.setTimeout(() => setCopied(''), 1500); }); } catch (e) { /* ignore */ }
  };
  const [open, setOpen] = useState(false);
  const allowed = !!currentUser && (currentUser.modules || []).includes('orders');
  useEffect(() => {
    if (!allowed) return;
    let alive = true;
    const load = () => {
      axios.get('/api/settings/aliexpress/orders/alerts', { headers: auth() })
        .then((r: any) => { if (alive) setItems((r.data && r.data.orders) || []); })
        .catch(() => { if (alive) setItems([]); });
    };
    load();
    const t = window.setInterval(load, 3 * 60 * 1000);
    return () => { alive = false; window.clearInterval(t); };
  }, [allowed]);
  if (!allowed || items.length === 0) return null;
  const minH = Math.min.apply(null, items.map((x: any) => Number(x.hours_left)));
  const red = minH < 12;
  return (
    <div style={{ background: red ? '#fef2f2' : '#fffbeb', borderBottom: '2px solid ' + (red ? '#dc2626' : '#f59e0b'), padding: '6px 14px', fontSize: 13, fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <b style={{ color: red ? '#b91c1c' : '#92400e' }}>⚠ AliExpress: {items.length} {items.length === 1 ? 'zamówienie czeka' : 'zamówień czeka'} na zgłoszenie wysyłki</b>
        <span style={{ color: red ? '#b91c1c' : '#92400e' }}>najbliższy termin: {left(minH)}</span>
        <button onClick={() => setOpen(!open)} style={{ padding: '2px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer' }}>{open ? 'Zwiń' : 'Pokaż'}</button>
        <button onClick={() => onOpen(items.map((x: any) => x.order_number).filter((n: any) => !!n))} style={{ padding: '2px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer' }}>Otwórz Zamówienia</button>
      </div>
      {open ? (
        <div style={{ marginTop: 6 }}>
          {items.map((x: any) => (
            <div key={x.ae_order_id} style={{ display: 'flex', gap: 10, flexWrap: 'wrap', padding: '3px 0', borderTop: '1px solid ' + (red ? '#fecaca' : '#fde68a') }}>
              <b title="Kliknij, aby skopiować" onClick={() => copy(x.order_number || String(x.ae_order_id))} style={{ fontFamily: 'monospace', cursor: 'copy' }}>{x.order_number || ('AE ' + x.ae_order_id)}</b>{copied === (x.order_number || String(x.ae_order_id)) ? <span style={{ color: '#15803d', fontWeight: 600 }}>✓ skopiowano</span> : null}
              <span style={{ color: Number(x.hours_left) < 12 ? '#b91c1c' : '#374151', fontWeight: 600 }}>zostało: {left(Number(x.hours_left))}</span>
              <span style={{ color: '#6b7280' }}>termin: {x.deadline_local}</span>
              <span style={{ color: x.label ? '#374151' : '#b91c1c' }}>{x.label ? ('etykieta ' + x.label + (x.fulfill_error ? ' — AliExpress odrzucił: ' + x.fulfill_error : ' — czeka na wysłanie do AliExpress (do 10 min)')) : 'brak etykiety'}</span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
